import { SETTINGS_TYPES } from '@/constant'
import { SettingsService } from '@/services/SettingsService'

export const DISABLE_INTERFACE_ANIMATIONS_SETTING =
  'disableInterfaceAnimationsAndSliderAutoplay'

export const isInterfaceAnimationsDisabled = (settings) => {
  const source = settings ?? SettingsService.get(SETTINGS_TYPES.GENERAL) ?? {}

  return source?.[DISABLE_INTERFACE_ANIMATIONS_SETTING] === '1'
}

export const getMotionSafeAutoplay = (settings, autoplayConfig) =>
  isInterfaceAnimationsDisabled(settings) ? false : autoplayConfig
